import React from 'react';

import styles from './cropperModalStyles';

import Modal from 'buyside/components/presentation/Modal/modal';
import ImageCropper from 'buyside/components/presentation/ImageCropper/imageCropper';

const CropperModal = ({
  isOpen,
  closeModal,
  title,
  aspectRatio,
  image,
  defaultImage,
  saveImage
}) => {
  return (
    <Modal isOpen={isOpen} onClose={closeModal} size={aspectRatio ? 'lg' : 'md'}>
      <div className={styles.cropper}>
        <ImageCropper
          title={title}
          aspectRatio={aspectRatio}
          image={image}
          defaultImage={defaultImage}
          saveImage={saveImage}
          onClose={closeModal}
        />
      </div>
    </Modal>
  );
};

export default CropperModal;
